import { Model } from '@models'
import { KUSTOMER_CONVERSATIONS } from '../graphql/kustomerConversations'
import { KUSTOMER_CONVERSATION_MESSAGES } from '../graphql/kustomerConversationMessages'
import { KUSTOMER_ARTICLES } from '../graphql/kustomerArticles'
import { KUSTOMER_ARTICLE_VERSIONS } from '../graphql/kustomerArticleVersions'
import { KUSTOMER_ARTICLE_VERSION_PREVIEW } from '../graphql/kustomerArticleVersionPreview'
import { KUSTOMER_CREATE_CONVERSATION } from '../graphql/kustomerCreateConversation'
import { reducers } from './supportHub.reducers'
import { SupportHubStoreState } from './supportHub.types'
export default class SupportHub {
  namespace = 'supportHub'

  state: SupportHubStoreState = {
    ...Model.defaultState,
    articles: [],
    articleVersionPreview: null,
    conversations: null,
    messages: [],
  }

  effects = {
    kustomerArticles: Model.buildEffect({
      name: `${this.namespace}/kustomerArticles`,
      query: KUSTOMER_ARTICLES,
      caching: false,
      reducers: [{ name: 'updateArticles' }],
    }),
    kustomerArticleVersions: Model.buildEffect({
      name: `${this.namespace}/kustomerArticleVersions`,
      query: KUSTOMER_ARTICLE_VERSIONS,
      caching: false,
      dataPath: 'kustomerArticleVersions',
    }),
    kustomerArticleVersionPreview: Model.buildEffect({
      name: `${this.namespace}/kustomerArticleVersionPreview`,
      query: KUSTOMER_ARTICLE_VERSION_PREVIEW,
      caching: false,
      reducers: [{ name: 'updateArticleVersionPreview' }],
    }),
    kustomerCreateConversation: Model.buildEffect({
      name: `${this.namespace}/kustomerCreateConversation`,
      query: KUSTOMER_CREATE_CONVERSATION,
      caching: false,
      dataPath: 'kustomerCreateConversation',
    }),
    kustomerConversations: Model.buildEffect({
      name: `${this.namespace}/kustomerConversations`,
      query: KUSTOMER_CONVERSATIONS,
      caching: false,
      reducers: [{ name: 'updateConversations' }],
    }),
    kustomerConversationMessages: Model.buildEffect({
      name: `${this.namespace}/kustomerConversationMessages`,
      query: KUSTOMER_CONVERSATION_MESSAGES,
      caching: false,
      reducers: [{ name: 'updateConversationMessages' }],
    }),
  }

  reducers = reducers
}
